<template>
  <v-row class="flex-column mt-6 pr-8">
    <router-view :key="$route.fullPath" />
    <v-col v-if="$route.name === 'Designations'">
      <v-row no-gutters>
        <v-col md="2"
          ><h2 class="title-1 ml-5 primary-text">Designations</h2></v-col
        >
        <v-col class="text-right">
          <v-btn icon class="mr-1" @click="resetAll">
            <v-icon>restart_alt</v-icon>
          </v-btn>
          <v-text-field
            v-model="search"
            class="custom-search"
            label="Search"
            solo
            append-icon="search"
            hide-details
            single-line
            @keyup="getDesignationList(), pageReset()"
          />
          <v-btn class="primary_btn small" depressed @click="openAddPopUp()"
            >Add Designation</v-btn
          >
          <v-dialog v-model="designationPopup" persistent max-width="800px">
            <v-card class="custom-dialog">
              <v-container>
                <v-card-tittle class="d-flex">
                  <span class="text-h5 text-uppercase font-weight-bold">{{
                    this.designation.id == 0
                      ? 'Add Designation'
                      : 'Edit Designation'
                  }}</span>
                  <v-spacer></v-spacer>
                  <v-btn icon color="black" @click="designationPopup = false,$refs.form.reset()">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-card-tittle>
                <v-form v-model="valid" class="form-right-view-table" ref="form">
                  <v-card-text>
                    <v-divider class="mb-10" />
                    <v-row class="no-gutters">
                      <v-col cols="6">
                        <v-text-field
                          v-model="designation.name"
                          label="Designation"
                          :rules="nameRules"
                          filled
                           @keyup="text=''"
                        />
                        <font color="red" class="v-virtual-table">{{
                          text
                        }}</font>
                      </v-col>
                    </v-row>
                  </v-card-text>
                  <!-- <v-container>
                    <v-divider />
                  </v-container> -->
                  <v-card-actions>
                    <v-spacer />
                    <v-btn
                      class="secondary-btn"
                      text
                      @click="designationPopup = false,$refs.form.reset()"
                    >
                      Cancel
                    </v-btn>
                    <v-btn
                      text
                      class="primary-btn"
                      @click="saveDesignation()"
                      :disabled="!valid || designationCheck()"
                    >
                      {{ this.designation.id == 0 ? 'Create' : 'Save' }}
                    </v-btn>
                  </v-card-actions>
                </v-form>
              </v-container>
            </v-card>
          </v-dialog>
        </v-col>
      </v-row>
    </v-col>
    <v-col v-if="$route.name === 'Designations'" class="custom-panel">
      <v-data-table
        id="designations"
        :headers="headers"
        :items="designations.data"
        :options.sync="options"
        :server-items-length="designations.total"
        :loading="loading"
        hide-default-footer
        :sort-desc.sync="sortDesc"
        :header-props="{ sortIcon: 'arrow_upward' }"
        class="elevation-1"
        @update:sort-desc="getDesignationList"
      >
        <template v-slot:item.name="{ item }">
          <b>
            {{ item.name }}
          </b>
        </template>
        <template v-slot:item.action="{ item }">
          <v-row>
            <v-col cols="6">
              <v-btn icon>
                <v-icon @click="openEditPopUp(item)">edit</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </template>
      </v-data-table>
      <div class="primary-icon">
        <license-pagination
          :total="designations.total"
          :value="page"
          @input="pageEmit"
        />
      </div>
    </v-col>
  </v-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import licensePagination from '@/components/LicensePagination/licensePagination.vue';
import { storeActions } from '@/store/actions.constants';
export default {
  components: { licensePagination },
  data: () => ({
    headers: [
      {
        text: 'Designation',
        align: 'start',
        value: 'name',
      },
      { text: 'Actions', value: 'action', sortable: false },
    ],
    search: '',
    loading: false,
    page: 1,
    itemsPerPage: 10,
    sortDesc: [],
    options: {},
    designationPopup: false,
    valid: false,
    text: '',
    designation: {
      id: 0,
      name: null,
    },
    nameRules: [
      (v) => !!v || 'Designation is Required',
      (v) =>
        /^[a-zA-Z][a-zA-Z0-9\s]{2,19}$/.test(v) ||
        'Intial spaces and Special characters and Initial numbers are not allowed and string length must be between 3 to 20.',
    ],
  }),
  computed: {
    ...mapGetters({
      designations: 'designations/getDesignations',
    }),
  },
  async mounted() {
    if (this.options.page !== undefined) await this.getDesignationList();
  },
  methods: {
    ...mapActions({
      getDesignations: 'designations/getDesignation',
      createDesignation: 'designations/createDesignation',
      updateDesignation: 'designations/updateDesignationById',
    }),
    pageReset() {
      if (this.search) {
        this.page = 1;
      }
    },
    pageEmit(data) {
      if (data > 0) this.page = data;
      this.getDesignationList();
    },
    resetAll() {
      this.search = '';
      this.page = 1;
      this.sortDesc = [];
      this.options.sortBy.length = 0;
      this.getDesignationList();
    },
    getDesignationList() {
      this.loading = true;
      const { sortBy } = this.options;
      this.getDesignations({
        page: this.page,
        limit: 10,
        search: this.search || '',
        sort: sortBy[0],
        desc: this.sortDesc[0] || 0,
      })
        .then((res) => {
          if (res.status === 200) {
            let items = res.data.data;
            this.loading = false;
          }
        })
        .catch((err) => {
          this.$store.dispatch(`snackbar/${storeActions.setSnackbarText}`, {
            text: err.response.data.message,
            timeout: 3000,
            color: 'error',
          });
        });
    },
    designationCheck() {
      if (this.designation.name == null || this.designation.name == '') {
        return true;
      } else {
        return false;
      }
    },
    async saveDesignation() {
      if (this.designation.id == 0) {
        this.desginationObj = await this.createDesignation({
          name: this.designation.name,
        });
        console.log(this.createDesignation);
        if (this.desginationObj.status === 200) {
          this.$store.dispatch(`snackbar/${storeActions.setSnackbarText}`, {
            text: 'Desgination Created Sucessfully',
            timeout: 1000,
            color: 'success',
          });
          this.designationPopup = false;
          this.getDesignationList();
        } else {
          this.text = this.desginationObj.data.message;
        }
      } else {
        const designationObj = {
          id: this.designation.id,
          name: this.designation.name,
        };
        this.updateDesignation(designationObj).then((res) => {
          if (res.status === 200) {
            this.$store.dispatch(`snackbar/${storeActions.setSnackbarText}`, {
              text: res.data.message,
              timeout: 1000,
              color: 'success',
            });
            this.designationPopup = false;
            this.getDesignationList();
          } else {
            this.text = res.data.message;
          }
        });
      }
    },
    openAddPopUp() {
      this.designationPopup = true;
      this.text = '';
      this.designation.id=0;
      this.$refs.form.reset();
    },
    openEditPopUp(item) {
      this.designationPopup = true;
      this.text = '';
      this.designation = {
        id: item.id,
        name: item.name,
      };
      
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/scss/colors.scss';

.v-dialog,
.custom-dialog {
  border-radius: 0px !important;
}
.custom-dialog {
  .v-card__text {
    min-height: 200px !important;
  }
  .v-input__control {
    border-radius: 0px;
  }
}
.icon {
  .v-icon {
    font-size: 24px;
    position: relative;
    top: -1px;
  }
}
.primary-button,
.secondary-btn {
  min-width: 140px !important;
  text-transform: uppercase !important;
  border-radius: 0px !important;
  font-size: 0.9rem !important;
}
.primary-button {
  background-color: $primary-button;
  color: $white !important;
}
.secondary-btn {
  background-color: transparent !important;
  border: 1px solid $seconday-button !important;
  color: $seconday-button !important;
}
</style>

